
import { defineComponent } from "vue";
import navBar from "../../components/nav-bar/nav-bar.vue";
import { api } from "../../assets/utils/config";
import { post, PostConfig } from "@/assets/utils/common";

export default defineComponent({
  components: { navBar },

  data() {
    return {
      loading: false,
      newsList: [],
    };
  },

  mounted() {
    this.getShowWebsiteKnowinfo();
  },

  methods: {
    getShowWebsiteKnowinfo() {
      let config: PostConfig = {
        url: api.getShowWebsiteKnowinfo,
      };
      this.loading = true;
      post(config).then((res) => {
        this.loading = false;
        if (res.status == 0) {
          this.newsList = res.data.slice(0, 7);
        }
      });
    },

    toNewsDetail(item: any) {
      if (item.link) window.open(item.link);
    },
  },
});
